<template>
  <div id="app">
    <div
      ref="spinner"
      class="spinnerWrapper"
    >
      <div class="spinner">
        <b-spinner />
      </div>
    </div>

    <Navbar />

    <div
      v-if="$route.path === '/'"
      class="header"
    >
      <span>
        {{ welcomeText }}
      </span>
    </div>

    <b-container
      :style="$route.path === '/' ? '' : 'margin-top: 70px'"
      style="margin-bottom: 10vh"
    >
      <router-view :key="$route.fullPath" />
    </b-container>

    <b-navbar
      type="light"
      variant="light"
      fixed="bottom"
    >
      <b-navbar-nav small>
        <b-nav-text>
          Diese Seite verzichtet auf Cookies.
        </b-nav-text>
      </b-navbar-nav>
      <b-navbar-nav
        small
        class="ml-auto"
      >
        <b-nav-item href="/Datenschutzerklärung.html">
          Datenschutzerklärung
        </b-nav-item>
        <b-nav-item href="/Impressum.html">
          Impressum
        </b-nav-item>
        <b-nav-item :href="adminDomain">
          Admin
        </b-nav-item>
      </b-navbar-nav>
    </b-navbar>
  </div>
</template>

<script>
import Navbar from './components/Nav/Navbar'
import { slideshow } from '@/helpers'
import { mapActions, mapGetters } from 'vuex'

export default {
  components: {
    Navbar
  },
  data () {
    return {}
  },
  computed: {
    ...mapGetters('config', [
      'getConfig',
      'configIsLoaded'
    ]),
    config () {
      if (!this.configIsLoaded) {
        return []
      }
      return this.getConfig
    },
    backgroundImages () {
      return this.config.BACKGROUND_IMAGES.split(',')
    },
    welcomeText () {
      return this.config.WELCOME_TEXT
    },
    title () {
      return this.config.TITLE
    },
    adminDomain () {
      return this.config.ADMIN_DOMAIN
    }
  },
  async mounted () {
    await this.fetchConfig()
    document.getElementById('app').style.backgroundImage = 'url("/images/' + this.backgroundImages[0] + '.jpg")'

    if (this.$route.path === '/' && this.backgroundImages.length > 1) {
      this.startFader()
    } else {
      this.removeLoader()
    }
  },
  methods: {
    ...mapActions('config', [
      'fetchConfig'
    ]),
    startFader () {
      slideshow(this.backgroundImages, 'app', 5, this.removeLoader)
    },
    removeLoader () {
      this.$refs.spinner.setAttribute('style', 'opacity: 0')
      setTimeout(() => {
        this.$refs.spinner.remove()
      }, 1000)
    }
  }
}
</script>

<style>
#app {
  height: 100vh;
  width: 100vw;
  position: absolute;
  overflow-y: scroll;
  background-repeat: no-repeat;
  background-size: cover;
}

.spinnerWrapper {
  z-index: 9999;
  background: white;
  width: 100%;
  height: 100%;
  position: absolute;
  transition: opacity, 0.5s ease;
  opacity: 1;
}

.spinner {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

#app .container {
  background-color: white;
  border-radius: 5px;
  margin: 0 auto 16px auto;
  padding: 8px 15px;
}

.header {
  height: 60vh;
  overflow: hidden;
  position: relative;
  margin: 0;
  padding: 0;
  border: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.header span {
  color: white;
  font-size: 300%;
  text-align: center;
  font-weight: 400;
  display: inline-block;
  position: relative;
  line-height: 1.15em;
  text-shadow: 0 15px 102px rgba(0, 0, 0, .7), 0 15px 40px rgba(0, 0, 0, .21);
}
</style>
